import { useEffect, useState } from "react";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { isStandardLob } from "../../services/userOnboardService/userOnboardService";
import { Loader } from "../../components/loader/Loader";
import Mdm from "./Mdm";
import DataUploadScreenLayout from "../../components/dataUploadLayout/dataUploadScreenLayout";

const SubscriptionBasedMdm = () => {
    const [loader, setLoader] = useState<boolean>(false);
    const [isStandard, setIsStandard] = useState(false);

    useEffect(() => {
        (async () => {
            setLoader(true);
            const portalConfig = await getMetaDataConfig(
                "clientconfig",
                "portal_configuration"
            );
if(portalConfig){
    setIsStandard(isStandardLob(portalConfig));
}
            setLoader(false);
        })();
    }, [])

    return (
        <>
        {
            loader ? <Loader /> : 
            isStandard ? <DataUploadScreenLayout disableNext={true} /> : <Mdm/>
        }
        </>
    );
}

export default SubscriptionBasedMdm;